 <template>
  <div class="info-region-container">
    <div
      class="all-content-container"
      v-allow="'0604'"
      style="margin: 0 auto; width: 100%; margin-top: 10px"
    >
      <div class="container1">
        <div class="titlemaun" style="">
          <div style="padding: 15px; border: ">
            <h3>生长记录</h3>
          </div>
          <div class="table-title-btn">
            <el-button type="primary" class="adduser" @click="handleReturn"
              >返回决策模型</el-button
            >
          </div>
        </div>
        <el-form :inline="true" :model="searchForm" class="demo-form-inline">
          <el-form-item>
            <el-button type="primary" class="button" @click="handleSearch"
              >查询</el-button
            >
            <el-button type="button" ass="button" @click="handleRest"
              >重置</el-button
            >
          </el-form-item>
        </el-form>
      </div>
      <div class="info-content-container">
        <div class="table_content1" style="margin-top: 10px">
          <el-table
            :data="tableData"
            align="center"
            class="data-table"
            v-loading="loading"
            style="width: 100%"
            :header-cell-style="{ background: '#F4F5F7' }"
          >
            <el-table-column align="center" label="作物名称">
              <template slot-scope="scope">
                <p>{{ scope.row.cropName }}</p>
              </template>
            </el-table-column>
            <el-table-column align="center" label="模型名称">
              <template slot-scope="scope">
                <p>{{ scope.row.modelName }}</p>
              </template>
            </el-table-column>
            <el-table-column align="center" label="模型阶段名称">
              <template slot-scope="scope">
                <p>{{ scope.row.modelStageName }}</p>
              </template>
            </el-table-column>
            <el-table-column align="center" label="模型周期名称">
              <template slot-scope="scope">
                <p>{{ scope.row.modelTimeName }}</p>
              </template>
            </el-table-column>
            <el-table-column align="center" label="作物生长图片">
              <template slot-scope="scope">
                <el-image
                  style="height: 50px"
                  :src="scope.row.image"
                  :preview-src-list="[scope.row.image]"
                  fit="contain"
                >
                </el-image>
              </template>
            </el-table-column>
            <el-table-column align="center" label="记录时间">
              <template slot-scope="scope">
                <p>{{ scope.row.recordTime }}</p>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="pagination-container">
          <div class="page"></div>
          <div class="pagination-content-container">
            <el-pagination
              background
              layout="prev, pager, next, jumper"
              class="pageTap"
              @current-change="handleCurrentChange"
              :current-page="searchForm.pageNum"
              :page-size="searchForm.pageSize"
              :total="total"
            ></el-pagination>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
 <script>
export default {
  data() {
    return {
      searchForm: {
        // 查询条件字段
        pageNum: 1,
        pageSize: 10,
        id: "",
      },
      total: 0, // 总数
      tableData: [],
    };
  },
  created() {
    // 查询
    this.getList();
  },
  methods: {
    // 查询
    handleSearch() {
      this.searchForm.pageNum = 1;
      this.getList();
    },
    // 重置
    handleRest() {
      this.searchForm = {
        pageNum: 1,
        pageSize: 10,
        decisionId: "",
      };
      this.getList();
    },
    // 分页查询
    handleCurrentChange: function (currentPage) {
      this.searchForm.pageNum = currentPage;
      this.getList();
    },
    // 分页获取列表
    getList() {
      this.loading = true;
      this.searchForm.id = this.$route.query.decisionId;
      this.$api.growthModel
        .getDataHisCropGrowthList(this.searchForm)
        .then((res) => {
          this.loading = false;
          if (res.code == 200) {
            this.tableData = res.data;
            this.total = res.count;
          }
        });
    },
    // 返回
    handleReturn() {
      this.$router.push({
        name: `decisionManagement`,
        query: {},
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.container1 {
  border: 1px solid rgba(232, 232, 232, 1);
}

.el-button {
  line-height: 0;
}

.all-content-container {
  width: 100%;
}

.titlemaun {
  display: flex;
  justify-content: space-between;
  height: 48px;
  border-bottom: 1px solid #ededed;
}

h4 {
  font-size: 14px;
  font-weight: 550;
  color: #000;
  height: 48px;
  line-height: 48px;
  padding-left: 18px;
}

.demo-ruleForm {
  width: 95%;
  margin: 0 auto;
  padding-top: 10px;

  .el-row {
    margin-bottom: 20px;
  }

  .el-select {
    width: 100% !important;
  }

  .el-input-number {
    width: 100% !important;
  }

  .el-cascader {
    width: 100% !important;
    margin-bottom: 0px !important;
  }
}
</style>